import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import includes from 'lodash/includes';
import without from 'lodash/without';
import { default as sort } from 'lodash/sortBy';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from 'antd';
import { updateSearchFilters as update } from '../../../../actions';
import { t } from '../../../../helpers/t';

const SelectorGroup = ({
  options, translationKeyPrefix, parameterName, sortBy,
}) => {
  const dispatch = useDispatch();
  const parameters = useSelector((state) => state.searchFilters.parameters[parameterName]) || [];
  const addSelectorToStore = (selectedItem) => (
    dispatch(update({ [parameterName]: [...parameters, selectedItem] }))
  );
  const removeSelectorFromStore = (selectedItem) => (
    dispatch(update({ [parameterName]: without(parameters, selectedItem) }))
  );
  const toggleFilter = (filterValue) => (
    includes(parameters, filterValue)
      ? removeSelectorFromStore(filterValue)
      : addSelectorToStore(filterValue)
  );

  return (
    <div className="selector-group">
      {(sort(options, sortBy)).map(({ value, label }) => (
        <div className="sf-form-tag" key={uniqueId(label)}>
          <Checkbox checked={includes(parameters, value)} onChange={() => toggleFilter(value)}>
            {
              translationKeyPrefix
                ? t(`${translationKeyPrefix}.${label}`)
                : label
            }
          </Checkbox>
        </div>
      ))}
    </div>
  );
};

SelectorGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })).isRequired,
  sortBy: PropTypes.string,
  translationKeyPrefix: PropTypes.string,
  parameterName: PropTypes.string.isRequired,
};

SelectorGroup.defaultProps = {
  translationKeyPrefix: null,
  sortBy: undefined,
};

export default SelectorGroup;
